"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTRACTS_ADDRESSES = exports.SHASTA_CONTRACTS_ADDRESSES_BASE58 = exports.TRON_CONTRACTS_ADDRESSES_BASE58 = exports.GasLimitOffset = exports.GasPrice_NOW = exports.NULL_ADDRESS = exports.API_BASE_URL = exports.CHAIN = exports.ID_CHAINNAME = exports.HOST_CHAINNAME = exports.CHAIN_ID = void 0;
var types_1 = require("./utils/types");
exports.CHAIN_ID = (_a = {},
    _a[types_1.Network.Tron] = 728126428,
    _a[types_1.Network.Shasta] = 2494104990,
    _a);
exports.HOST_CHAINNAME = {
    'https://api.trongrid.io': types_1.Network.Tron,
    'https://api.shasta.trongrid.io': types_1.Network.Shasta,
};
exports.ID_CHAINNAME = {
    728126428: types_1.Network.Tron,
    2494104990: types_1.Network.Shasta,
};
exports.CHAIN = (_b = {},
    _b[types_1.Network.Tron] = 'tron',
    _b[types_1.Network.Shasta] = 'tron',
    _b);
exports.API_BASE_URL = (_c = {},
    _c[types_1.Network.Tron] = {
        api: 'https://api.apenft.io',
        api2: 'https://api.apenft.io',
        key: 'rV9UjZwMSK4zqkKEWOUnUXXY2zNgPJ8i',
        secret: 'X6nsVJtRzySGjXvsfRN5RAweKtFtLKBZ',
        apenftBaseApiUrl: 'https://api-gateway.apenft.io'
    },
    _c[types_1.Network.Shasta] = {
        api: 'https://api-testnet.apenft.io',
        api2: 'https://api-testnet.apenft.io',
        key: 'ewSLIdRTSkss2oFsBFdCuO113l0zXX2K',
        secret: 'Km8wDTfjIF5lwJl4qpouzeqNMrd78K1w',
        apenftBaseApiUrl: 'https://api-gateway-dev.apenft.io'
    },
    _c);
// base58
exports.NULL_ADDRESS = 'T9yD14Nj9j7xAB4dbGeiX9h8unkKHxuWwb';
exports.GasPrice_NOW = {
    url: 'https://www.gasnow.org/api/v3/gas/price',
    type: 'fast' //standard
};
exports.GasLimitOffset = 1.18;
var TRON_CONTRACTS_ADDRESSES_BASE58;
(function (TRON_CONTRACTS_ADDRESSES_BASE58) {
    TRON_CONTRACTS_ADDRESSES_BASE58["ERC20AssetProxy"] = "TRgSk4foxSg4JaV2EjNz8qzaNrBhUtWUnz";
    TRON_CONTRACTS_ADDRESSES_BASE58["ERC721AssetProxy"] = "TRJ54KCbg29a4nb8LVPgNp61o2ity2WkDu";
    TRON_CONTRACTS_ADDRESSES_BASE58["ERC1155AssetProxy"] = "TQPdK4DutVPkFhcWP6KqshpyRBT95zS2CE";
    TRON_CONTRACTS_ADDRESSES_BASE58["APENFTExchange"] = "TQr5axvJzETeHsUiXv6QjBEh1BKH571AZu";
    TRON_CONTRACTS_ADDRESSES_BASE58["ExchangeHelper"] = "TYxaWsBNMtE9L1bsUUdXCKm99Ab2jziEbA";
    TRON_CONTRACTS_ADDRESSES_BASE58["APENFTExchangeKeeper"] = "TEQAs54FPKYQdTZAPyT3okfbq2MH4dEeP1";
    TRON_CONTRACTS_ADDRESSES_BASE58["APENFTSharedAsset"] = "TG8UTFQfcmyqb3bSjqK1svTtzrn2mLcUXS";
    TRON_CONTRACTS_ADDRESSES_BASE58["FeeRecipientAddress"] = "TPyjyZfsYaXStgz2NmAraF1uZcMtkgNan5";
    TRON_CONTRACTS_ADDRESSES_BASE58["WTRX"] = "TNUC9Qb1rRpS5CbWLmNMxXBjyFoydXjWFR";
})(TRON_CONTRACTS_ADDRESSES_BASE58 = exports.TRON_CONTRACTS_ADDRESSES_BASE58 || (exports.TRON_CONTRACTS_ADDRESSES_BASE58 = {}));
var SHASTA_CONTRACTS_ADDRESSES_BASE58;
(function (SHASTA_CONTRACTS_ADDRESSES_BASE58) {
    SHASTA_CONTRACTS_ADDRESSES_BASE58["ERC20AssetProxy"] = "TC7G2nApC3WKGkkkrppUJSmNSnj7KYkaiq";
    SHASTA_CONTRACTS_ADDRESSES_BASE58["ERC721AssetProxy"] = "TVDuLb8zE9mcMJqMtUD1gMTnFKRZduwhb7";
    SHASTA_CONTRACTS_ADDRESSES_BASE58["ERC1155AssetProxy"] = "TEHxYWo9AkzMy2CFAghQQgBNCgBMqtZGKa";
    SHASTA_CONTRACTS_ADDRESSES_BASE58["APENFTExchange"] = "TYnuR3ripQNZUYUvjkjzbwQ48zHKdAtzis";
    SHASTA_CONTRACTS_ADDRESSES_BASE58["ExchangeHelper"] = "TCWuXtzPEqKJ2MLygtCr27i1ehYFJKDBdT";
    SHASTA_CONTRACTS_ADDRESSES_BASE58["APENFTExchangeKeeper"] = "TEdP593yFJkAiBzwdT56JrXW1pohsTA4ag";
    SHASTA_CONTRACTS_ADDRESSES_BASE58["APENFTSharedAsset"] = "TG8UTFQfcmyqb3bSjqK1svTtzrn2mLcUXS";
    SHASTA_CONTRACTS_ADDRESSES_BASE58["FeeRecipientAddress"] = "TRxMn4k6ZpPhHLEqVojaXRzr3PP3p3B9KE";
    SHASTA_CONTRACTS_ADDRESSES_BASE58["WTRX"] = "TF2ipqRnrDzuPrANJCJggmaM753FCE1ZWE";
    SHASTA_CONTRACTS_ADDRESSES_BASE58["ERC721Asset"] = "TKGSPEk2FLrEod8bTLCxxS9AbeXvYe21aC";
    SHASTA_CONTRACTS_ADDRESSES_BASE58["ERC20Asset"] = "TTRjXLinU9FAZETtL5TDNsQGd7sc7Hu26T";
    SHASTA_CONTRACTS_ADDRESSES_BASE58["ERC1155Asset"] = "TD34cLBPdDhjRHDgiWkG42LnbCZk5fP2fP";
    SHASTA_CONTRACTS_ADDRESSES_BASE58["FactoryContract"] = ""; // Leaving blank does not initialize the contract
})(SHASTA_CONTRACTS_ADDRESSES_BASE58 = exports.SHASTA_CONTRACTS_ADDRESSES_BASE58 || (exports.SHASTA_CONTRACTS_ADDRESSES_BASE58 = {}));
exports.CONTRACTS_ADDRESSES = (_d = {},
    _d[types_1.Network.Tron] = TRON_CONTRACTS_ADDRESSES_BASE58,
    _d[types_1.Network.Shasta] = SHASTA_CONTRACTS_ADDRESSES_BASE58,
    _d);
